<template>
  <div class="info-page">
    <div class="content-card">
      <div class="marketing-header">
        <img src="../assets/app-icon.png" alt="Logo" class="marketing-logo">
        <h2>港式台牌計番神器</h2>
        <p>Authorized Sellers for Apps (app-ads.txt) has been implemented.</p>
      </div>

      <div class="marketing-footer">
        <p>Marketing content is available on the App Store and Google Play Store.</p>
      </div>

      <button class="back-link" @click="$router.push('/settings')">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketingPage'
}
</script>

<style scoped>
.info-page {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.content-card {
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  text-align: center;
}

.marketing-header {
  margin-bottom: 20px;
}

.marketing-logo {
  width: 80px;
  height: 80px;
  border-radius: 18px;
  margin-bottom: 16px;
}

h2 {
  color: #2d3748;
  margin: 0;
  font-size: 1.8rem;
}

.marketing-footer {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #edf2f7;
}

p {
  color: #718096;
}

.back-link {
  margin-top: 30px;
  background: #f0f2f5;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}

.back-link:hover {
  background: #e2e8f0;
}
</style>
